import * as App from "@timesheets/routes-app";

import { RouteConfig } from "vue-router";
import { Setting } from "@timesheets/constants-common";

export const settings: RouteConfig[] = [
  {
    path: App.Settings.Root,
    name: Setting.CollectionName,
    component: async () => import("Dashboard/components/Settings/SettingsList.vue"),
  },
  {
    path: App.Settings.RecruitmentAgencyAdministrationRole.Branding,
    name: Setting.CollectionName + "-RecruitmentAgencyAdministrationRole-" + Setting.Branding.Name,
    component: async () => import("Dashboard/components/Settings/RecruitmentAgencyAdministrationRole/Branding/Index.vue"),
  },
  {
    path: App.Settings.RecruitmentAgencyAdministrationRole.Emails.Root,
    name: Setting.CollectionName + "-RecruitmentAgencyAdministrationRole-" + Setting.Emails.Name,
    component: async () => import("Dashboard/components/Settings/RecruitmentAgencyAdministrationRole/Emails/Index.vue"),
  },
  {
    path: App.Settings.RecruitmentAgencyAdministrationRole.Timesheets.Root,
    name: Setting.CollectionName + "-RecruitmentAgencyAdministrationRole-" + Setting.Timesheets.Name,
    component: async () => import("Dashboard/components/Settings/RecruitmentAgencyAdministrationRole/Timesheets/Index.vue"),
  },
  {
    path: App.Settings.RecruitmentAgencyAdministrationRole.Timesheets.GeneralSetup,
    name: Setting.CollectionName + "-RecruitmentAgencyAdministrationRole-" + Setting.Timesheets.GeneralSetup.Name,
    component: async () => import("Dashboard/components/Settings/RecruitmentAgencyAdministrationRole/Timesheets/GeneralSetup/Index.vue"),
  },
  {
    path: App.Settings.RecruitmentAgencyAdministrationRole.Timesheets.EntryTypes,
    name: Setting.CollectionName + "-RecruitmentAgencyAdministrationRole-" + Setting.Timesheets.EntryTypes.Name,
    component: async () => import("Dashboard/components/Settings/RecruitmentAgencyAdministrationRole/Timesheets/EntryTypes/Index.vue"),
  },

  // // Role settings
  // {
  //   path: App.Settings.RecruitmentAgencyAdministrationRole.Downloads,
  //   name: Setting.CollectionName + "-RecruitmentAgencyAdministrationRole-" + Setting.Downloads.Name,
  //   component: async () => import("Dashboard/components/Settings/Downloads/RecruitmentAgencyAdministrationRole/Index.vue"),
  // },
  // {
  //   path: App.Settings.ContractingRole.Downloads,
  //   name: Setting.CollectionName + "-ContractingRole-" + Setting.Downloads.Name,
  //   component: async () => import("Dashboard/components/Settings/Downloads/ContractingRole/Index.vue"),
  // },
  // {
  //   path: App.Settings.AuthorisingRole.Downloads,
  //   name: Setting.CollectionName + "-AuthorisingRole-" + Setting.Downloads.Name,
  //   component: async () => import("Dashboard/components/Settings/Downloads/AuthorisingRole/Index.vue"),
  // },

  // Email settings
  {
    path: App.Settings.ContractingRole.Emails,
    name: Setting.CollectionName + "-ContractingRole-" + Setting.Emails.Name,
    component: async () => import("Dashboard/components/Settings/ContractingRole/Emails/Index.vue"),
  },
  {
    path: App.Settings.AuthorisingRole.Emails,
    name: Setting.CollectionName + "-AuthorisingRole-" + Setting.Emails.Name,
    component: async () => import("Dashboard/components/Settings/AuthorisingRole/Emails/Index.vue"),
  },

  // Recruitment Agency settings
  {
    path: App.Settings.RecruitmentAgencyAdministrationRole.RecruitmentAgency.Root,
    name: Setting.CollectionName + "-RecruitmentAgencyAdministrationRole-" + Setting.RecruitmentAgency.Name,
    component: async () => import("Dashboard/components/Settings/RecruitmentAgencyAdministrationRole/RecruitmentAgency/Root/Index.vue"),
  },

  // Recruitment Agency financials settings
  {
    path: App.Settings.RecruitmentAgencyAdministrationRole.RecruitmentAgency.Financials,
    name: Setting.CollectionName + "-RecruitmentAgencyAdministrationRole-" + Setting.RecruitmentAgency.Financials.Name,
    component: async () => import("Dashboard/components/Settings/RecruitmentAgencyAdministrationRole/RecruitmentAgency/Financials/Index.vue"),
  },

  // Recruitment Agency documents settings
  {
    path: App.Settings.RecruitmentAgencyAdministrationRole.RecruitmentAgency.Documents,
    name: Setting.CollectionName + "-RecruitmentAgencyAdministrationRole-" + Setting.RecruitmentAgency.Documents.Name,
    component: async () => import("Dashboard/components/Settings/RecruitmentAgencyAdministrationRole/RecruitmentAgency/Documents/Index.vue"),
  },

  // Beta access
  {
    path: App.Settings.RecruitmentAgencyAdministrationRole.BetaAccess,
    name: Setting.CollectionName + "-RecruitmentAgencyAdministrationRole-" + Setting.BetaAccess.Name,
    component: async () => {
      return import("Dashboard/components/Settings/RecruitmentAgencyAdministrationRole/BetaAccess/Index.vue");
    },
  },
];
